import React from 'react'
import { DocumentSection } from '../../../entities/Document'
import { StatusIcon } from '../../../shared/ui/StatusIcon'
import { 
  CardsContainer,
  SectionCard,
  CardHeader,
  CardSectionNumber,
  CardSectionCode,
  CardSectionTitle,
  CardSectionIcon,
  CardTitleContainer,
  CardStatusContainer,
  CardStatusGroup,
  CardStatusLabel
} from '../DocumentationMatrix.styles'
import { ItemStatus } from '../../../api/documentation/types/model'

interface CardViewProps {
  sections: DocumentSection[]
}

export const CardView: React.FC<CardViewProps> = ({ sections }) => {
  // Функция для разделения кода и названия документа
  const parseSectionTitle = (title: string) => {
    const match = title.match(/^(\d+_[А-Я]+)\s+(.+)$/)
    if (match) {
      return {
        code: match[1],
        title: match[2]
      }
    }
    return {
      code: '',
      title: title
    }
  }



  const renderSectionCard = (section: DocumentSection, level: number = 0) => {
    const { code, title } = parseSectionTitle(section.title)
    
    return (
      <React.Fragment key={section.id}>
        <SectionCard nested={level > 0}>
          <CardHeader>
            <CardSectionNumber>{section.sectionNumber}</CardSectionNumber>
            {level > 0 && (
              <CardSectionIcon>
                ↳
              </CardSectionIcon>
            )}
            <CardTitleContainer>
              {code && <CardSectionCode>{code}</CardSectionCode>}
              <CardSectionTitle>{title}</CardSectionTitle>
            </CardTitleContainer>
          </CardHeader>
        
          <CardStatusContainer>
            <CardStatusGroup>
              <CardStatusLabel>Проектная документация</CardStatusLabel>
              <StatusIcon 
                status={section.status || ItemStatus.NA} 
                isCompact={true}
                size={16}
                onClick={() => {}}
              />
            </CardStatusGroup>
            
            <CardStatusGroup>
              <CardStatusLabel>Рабочая документация</CardStatusLabel>
              <StatusIcon 
                status={section.status || ItemStatus.NA} 
                isCompact={true}
                size={16}
                onClick={() => {}}
              />
            </CardStatusGroup>
          </CardStatusContainer>
        </SectionCard>
        
        {section.subsections.map(subsection => 
          renderSectionCard(subsection, level + 1)
        )}
      </React.Fragment>
    )
  }

  return (
    <CardsContainer>
      {sections.map(section => renderSectionCard(section))}
    </CardsContainer>
  )
}
